import { Button } from '@chakra-ui/react';

import { FirstAccessCredentials } from '../..';
import { useFirstAccess } from '../../hooks/useFirstAccess';
import firstAccessSchema from '../../validators/firstAccessSchema';

import { FieldWrapper, Form, TextInput } from '@/components/Form';
import * as LC from '@/components/LC';

type FirstAccessFormProps = {
  onSuccess: () => void;
  onError: (message: string) => void;
};

export const FirstAccessForm: React.FC<FirstAccessFormProps> = ({ onSuccess, onError }) => {
  const { mutateAsync, isLoading } = useFirstAccess();

  const handleSubmit = async (values: FirstAccessCredentials): Promise<void> => {
    try {
      await mutateAsync(values);
      onSuccess();
    } catch (err: any) {
      onError(err.response.data.error);
    }
  };

  return (
    <Form<FirstAccessCredentials>
      initialValues={{
        email: '',
        newPassword: '',
        temporaryPassword: '',
      }}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={firstAccessSchema}
    >
      {() => (
        <LC.Vertical w="100%">
          <FieldWrapper
            name="email"
            helper="Insert a valid email"
            required
            label="Email"
            as={(props) => <TextInput type="email" {...props} />}
          />
          <FieldWrapper
            name="newPassword"
            helper="Insert a new valid password"
            required
            label="New password"
            as={(props) => <TextInput type="password" {...props} />}
          />
          <FieldWrapper
            name="temporaryPassword"
            helper="Insert a temporary password"
            required
            label="Temporary password"
            as={(props) => <TextInput type="password" {...props} />}
          />

          <LC.Vertical center spaceBetween>
            <Button
              isLoading={isLoading}
              type="submit"
              className="w-full"
              variant="@primary"
              w="100%"
            >
              Criar
            </Button>
          </LC.Vertical>
        </LC.Vertical>
      )}
    </Form>
  );
};
